<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <!-- <router-link class="btn btn-primary" to="/dashboard/splash">add new item</router-link> -->
            <div class="table-responsive">
              <table id="sorting-table" class="table mb-0">
                <thead>
                  <tr>
                    <th>ایندکس</th>
                    <th>نام اچیومنت</th>
                    <th>جایزه</th>
                    <th>جزییات</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="splash in splashes" :key="splash._id">
                    <td>{{ splash.AchievementIndex }}</td>
                    <td>{{ splash.AchievementName }}</td>
                    <td>{{ splash.prize }}</td>
                    <td>
                      <button class="btn btn-gradient-01" @click="showModal(splash)">تغییر جایزه</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
    </div>
    <!-- End Row -->
    <change :modal="modalData" @clicked="edit"></change>
  </div>
</template>

<script>
import splashService from '../../../../services/achievement';
export default {
  name: 'league',
  components: {
    change: () => import('./achievementChange'),
  },
  data() {
    return {
      splashes: [],
      modalData: { title: '' },
    };
  },
  created() {
    this.getLicenses();
  },
  methods: {
    async getLicenses() {
      try {
        const splashes = await splashService.getAllAchievements();
        this.splashes = splashes;
      } catch (err) {
        console.log(err);
      }
    },
    showModal(splash) {
      this.modalData = splash;
      window.$('#AchievementChange').modal('show');
    },
    async edit(splash) {
      try {
        await splashService.EditAchievement(splash);
        window.$('#AchievementChange').modal('hide');
        this.getLicenses();
        window.notif({ isError: false, mssg: 'انجام شد' });
      } catch (err) {
        window.notif({ isError: true, mssg: 'مشکلی پیش آمده' });
      }
    },
  },
};
</script>
